import { InjectionToken } from '@angular/core';

// referrals-eb0a7e7440 will be replaced during build step,
// it is used by sentry to match sourcemaps

export const AppRevisionToken = new InjectionToken('APP_REVISION');
export const AppRevisionProvider = {
  provide: AppRevisionToken,
  useValue: `referrals-eb0a7e7440`,
};
